module.exports = __webpack_public_path__ + "static/media/cars.f58b9a8a.svg";